import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./CentralGovScholarship.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CentralGovScholarship = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    youtubeLink: "",
    officialLink: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/scholarships`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: formData.title,
          description: formData.description,
          youtubeLink: formData.youtubeLink,
          officialLink: formData.officialLink,
          type: "Central",
        }),
      });
      if (response.ok) {
        alert("Scholarship saved successfully!");
        navigate("/student-scholarship/all-central-government");
      } else {
        alert("Failed to save the scholarship. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while saving the scholarship.");
    }
  };

  return (
    <div id="central-gov-scholarship-main-container">
      <div className="central-gov-heading-main-div">
        <h4>Central Government Scholarship</h4>
        <div className="header-main-btns">
          <button>Central Gov Scholarship</button>
          <button
            onClick={() =>
              navigate("/student-scholarship/all-central-government")
            }
          >
            All Central Gov Scholarship
          </button>
        </div>
      </div>
      <div className="central-gov-scholarship-inner">
        <form onSubmit={handleSubmit}>
          <div className="central-gov-input">
            <label>
              <b>Title</b>
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter Title"
              required
            />
          </div>
          <div className="central-gov-input">
            <label>
              <b>Description</b>
            </label>
            {/* <textarea
              name="description"
              style={{ height: "120px" }}
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Type description"
              required
            ></textarea> */}
            <ReactQuill
              theme="snow"
              placeholder="Enter Description"
              value={formData.description}
              onChange={(value) =>
                setFormData((prevData) => ({ ...prevData, description: value }))
              }
            />
          </div>
          <div className="central-gov-input">
            <label>
              <b>Youtube Link</b>
            </label>
            <input
              type="text"
              name="youtubeLink"
              value={formData.youtubeLink}
              onChange={handleInputChange}
              placeholder="Enter YouTube Link"
            />
          </div>
          <div className="central-gov-input">
            <label>
              <b>Other Link</b>
            </label>
            <input
              type="text"
              name="officialLink"
              value={formData.officialLink}
              onChange={handleInputChange}
              placeholder="Enter Other Link"
            />
          </div>
          <div className="new-chapter-form-buttons">
            <button type="submit" className="new-chapter-submit-btn">
              Save
            </button>
            <button
              type="button"
              className="new-chapter-cancel-btn"
              onClick={() =>
                navigate("/student-scholarship/all-central-government")
              }
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CentralGovScholarship;
